import { createSlice } from "@reduxjs/toolkit";
import { CheckboxDropdownItem } from "../../../shared/utils/interfaces/settingsInterface";
import { IKit } from "../../../shared/utils/interfaces/interviewKit";
import { EvaluationActionType } from "../../../shared/utils/interfaces/evaluation";

const interviewSlice = createSlice({
  name: "interview",
  initialState: {
    isInterviewKitNameModalOpen: false,
    isKitSaved: false,
    selectedKit: {},
    isGenerateNewKit: false,
    allKits: [],
    evaluationSections: [],
    showPreview: false,
    evaluationView: false,
    selectedKitTemplateData: {},
    generateSectionWithAI: false,
    deleteEvaluationModal: false,
    isGenerateEvaluationKitModalOpen: false,
    isEditingKit: false,
    evaluationId: undefined,
    isLoadingEvaluationData: false,
    selectedTemplate: {},
    templates: [],
    isCreatingNewTemplate: false,
    selectedTemplateData: {},
    oldSelectedTemplateData: {},
    isClickingUseContent: false,
    isRecordedInterviewModalOpen: false,
    isViewEvaluationModalOpen: false,
    isEvaluationQuestionsModal: false,
    isStartingWithEvaluationKit: false,
    isSuccessSavingEvaluationKitTosStage: false,
    evaluationActionType: null,
    recordedVideoUrl: '',
    aiEvaluationId: '',
  },
  reducers: {
    setInterviewKitNameModalOpen: (state, action) => {
      state.isInterviewKitNameModalOpen = action.payload;
    },
    setKitSaved: (state, action) => {
      state.isKitSaved = action.payload;
    },
    setGenerateNewKit: (state, action) => {
      state.isGenerateNewKit = action.payload;
    },
    setSelectedKit: (state, action) => {
      state.selectedKit = action.payload;
    },
    setAllKits: (state, action) => {
      state.allKits = action.payload;
    },
    setEvaluationSections: (state, action) => {
      state.evaluationSections = action.payload;
    },
    setShowPreview: (state, action) => {
      state.showPreview = action.payload;
    },
    setEvaluationView: (state, action) => {
      state.evaluationView = action.payload;
    },
    setSelectedKitTemplateData: (state, action) => {
      state.selectedKitTemplateData = action.payload;
    },
    setIsEditingKit: (state, action) => {
      state.isEditingKit = action.payload;
    },
    setGenerateSectionWithAI: (state, action) => {
      state.generateSectionWithAI = action.payload;
    },
    setDeleteEvaluationModal: (state, action) => {
      state.deleteEvaluationModal = action.payload;
    },
    setGenerateEvaluationKitModal: (state, action) => {
      state.isGenerateEvaluationKitModalOpen = action.payload;
    },
    setEvaluationId: (state, action) => {
      state.evaluationId = action.payload;
    },
    setIsLoadingEvaluationData: (state, action) => {
      state.isLoadingEvaluationData = action.payload;
    },
    setSelectedTemplate: (state, action) => {
      state.selectedTemplate = action.payload;
    },
    setTemplates: (state, action) => {
      state.templates = action.payload;
    },
    setIsCreatingNewTemplate: (state, action) => {
      state.isCreatingNewTemplate = action.payload;
    },
    setSelectedTemplateData: (state, action) => {
      state.selectedTemplateData = action.payload;
    },
    setOldSelectedTemplateData: (state, action) => {
      state.oldSelectedTemplateData = action.payload;
    },
    setIsClickingUseContent: (state, action) => {
      state.isClickingUseContent = action.payload;
    },
    setIsRecordedInterviewModalOpen: (state, action) => {
      state.isRecordedInterviewModalOpen = action.payload;
    },
    setIsViewEvaluationModalOpen: (state, action) => {
      state.isViewEvaluationModalOpen = action.payload;
    },
    setIsEvaluationQuestionsModal: (state, action) => {
      state.isEvaluationQuestionsModal = action.payload;
    },
    setIsStartingWithEvaluationKit: (state, action) => {
      state.isStartingWithEvaluationKit = action.payload;
    },
    setIsSuccessSavingEvaluationKitTosStage: (state, action) => {
      state.isSuccessSavingEvaluationKitTosStage = action.payload;
    },
    setEvaluationActionType: (state, action) => {
      state.evaluationActionType = action.payload;
    },
    setRecordedVideoUrl: (state, action) => {
      state.recordedVideoUrl = action.payload;
    },
    setAiEvaluationId: (state, action) => {
      state.aiEvaluationId = action.payload;
    },
  }
});

export const {
  setInterviewKitNameModalOpen,
  setKitSaved,
  setGenerateNewKit,
  setSelectedKit,
  setAllKits,
  setEvaluationSections,
  setShowPreview,
  setEvaluationView,
  setSelectedKitTemplateData,
  setGenerateSectionWithAI,
  setDeleteEvaluationModal,
  setGenerateEvaluationKitModal,
  setIsEditingKit,
  setEvaluationId,
  setIsLoadingEvaluationData,
  setSelectedTemplate,
  setTemplates,
  setIsCreatingNewTemplate,
  setSelectedTemplateData,
  setOldSelectedTemplateData,
  setIsClickingUseContent,
  setIsRecordedInterviewModalOpen,
  setIsViewEvaluationModalOpen,
  setIsEvaluationQuestionsModal,
  setIsStartingWithEvaluationKit,
  setIsSuccessSavingEvaluationKitTosStage,
  setEvaluationActionType,
  setRecordedVideoUrl,
  setAiEvaluationId,
} = interviewSlice.actions;

export default interviewSlice.reducer;
export const selectInterviewKitNameModalOpen = (state: {
  interview: { isInterviewKitNameModalOpen: boolean };
}) => state.interview.isInterviewKitNameModalOpen;
export const selectIsKitSaved = (state: { interview: { isKitSaved: boolean } }) =>
  state.interview.isKitSaved;
export const selectSelectedKit = (state: {
  interview: { selectedKit: CheckboxDropdownItem };
}) => state.interview.selectedKit;
export const selectGenerateNewKit = (state: {
  interview: { isGenerateNewKit: boolean };
}) => state.interview.isGenerateNewKit;
export const selectAllKits = (state: { interview: { allKits: CheckboxDropdownItem[] } }) =>
  state.interview.allKits;
export const selectEvaluationSections = (state: {
  interview: { evaluationSections: any };
}) => state.interview.evaluationSections;
export const selectShowPreview = (state: { interview: { showPreview: boolean } }) =>
  state.interview.showPreview;
export const selectEvaluationView = (state: {
  interview: { evaluationView: boolean };
}) => state.interview.evaluationView;
export const selectSelectedKitTemplateData = (state: {
  interview: { selectedKitTemplateData: IKit };
}) => state.interview.selectedKitTemplateData;
export const selectIsEditingKit = (state: {
  interview: { isEditingKit: boolean };
}) => state.interview.isEditingKit;
export const selectGenerateSectionWithAI = (state: {
  interview: { generateSectionWithAI: boolean };
}) => state.interview.generateSectionWithAI;
export const selectDeleteEvaluationModal = (state: {
  interview: { deleteEvaluationModal: boolean };
}) => state.interview.deleteEvaluationModal;
export const selectEvaluationId = (state: {
  interview: { evaluationId: number }
}) => state.interview.evaluationId;
export const selectIsLoadingEvaluationData = (state: {
  interview: { isLoadingEvaluationData: boolean }
}) => state.interview.isLoadingEvaluationData;
export const selectIsGenerateEvaluationKitOpen = (state: {
  interview: { isGenerateEvaluationKitModalOpen: boolean };
}) => state.interview.isGenerateEvaluationKitModalOpen;
export const selectAllTemplates = (state: {
  interview: { templates: CheckboxDropdownItem[] }
}) => state.interview.templates;
export const selectIsCreatingNewTemplate = (state: {
  interview: { isCreatingNewTemplate: boolean }
}) => state.interview.isCreatingNewTemplate;
export const selectSelectedTemplateData = (state: {
  interview: { selectedTemplateData: IKit };
}) => state.interview.selectedTemplateData;
export const selectOldSelectedTemplateData = (state: {
  interview: { oldSelectedTemplateData: IKit };
}) => state.interview.oldSelectedTemplateData;
export const selectIsClickingUseContent = (state: {
  interview: { isClickingUseContent:boolean };
}) => state.interview.isClickingUseContent;
export const selectSelectedTemplate = (state: { interview: { selectedTemplate: CheckboxDropdownItem } }) => state.interview.selectedTemplate;

export const selectIsRecordedInterviewModalOpen = (state: {
  interview: { isRecordedInterviewModalOpen: boolean };
}) => state.interview.isRecordedInterviewModalOpen;

export const selectIsViewEvaluationModalOpen = (state: {
  interview: { isViewEvaluationModalOpen: boolean };
}) => state.interview.isViewEvaluationModalOpen;
export const selectIsEvaluationQuestionsModal = (state: { 
  interview: { isEvaluationQuestionsModal: boolean } 
}) => state.interview.isEvaluationQuestionsModal;
export const selectIsStartingWithEvaluationKit = (state: {
  interview: { isStartingWithEvaluationKit: boolean }
}) => state.interview.isStartingWithEvaluationKit;
export const selectIsIsSuccessSavingEvaluationKitTosStage = (state: {
  interview: { isSuccessSavingEvaluationKitTosStage: boolean }
}) => state.interview.isSuccessSavingEvaluationKitTosStage;
export const selectEvaluationActionType = (state: {
  interview: { evaluationActionType: EvaluationActionType }
}) => state.interview.evaluationActionType;
export const selectRecordedVideoUrl = (state: {
  interview: { recordedVideoUrl: string }
}) => state.interview.recordedVideoUrl;
export const selectAiEvaluationId = (state: {
  interview: { aiEvaluationId: string }
}) => state.interview.aiEvaluationId;
